import React, {Component} from 'react';
import Pagination from '../../Shared/components/components/Pagination/Pagination';
import EntityList from "./EntityList";
import EntitiesFilter from "./EntitiesFilter/EntitiesFilter";
import MapContainer from "./Map/MapContainer";
import ItemList_Schema_org from "../../Shared/components/components/ItemList/ItemList_Schema_org";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ADS_TYPES, AdsManagerContainer} from "../../Ads/components/AdsManagerContainer";

class EntityListContainer extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            showAnimalPreview: false,
            idAnimalPreview: 0,
            indexSelected: undefined,
            imageLoadedArray: []
        }
        
        
        this.handleHide = this.handleHide.bind(this);
        this.onClickPagination = this.onClickPagination.bind(this);
        this.renderentitiesList = this.renderentitiesList.bind(this);
    }
    
    
    handleHide() {
        this.setState({
            ...this.state,
            indexSelected: undefined
        });
    }
    
    
    renderentitiesList(showentitiesList) {
        //console.log("EntityListContainer::renderentitiesList()");
        let classReady = "";
        //TODO 27/2/22 10:48: cambiar esto
        if (this.props.entities.list.length === 0 || !showentitiesList) {
            
            return (
                <div id="not-found-container" className="">
                    <h1 className="not-found-animal-head animated-500ms fadeInDown">Ups! No encontramos nada con esas
                        características</h1>
                    
                    <div className="not-found-animal-description animated-500ms fadeInDown">Modifica los filtros para
                        encontrar lo que buscas
                    </div>
                    <LazyLoadImage className="image-not-found-animals animated-500ms fadeIn"
                                   src={process.env.CDN_URL + '/images/adoptaunanimal/animals/cat-gray.gif'}
                                   threshold={150}
                        // src={getImageEncode("not_found_animals")}
                                   alt="image-not-found-animals" width="1080" height="785"/>
                </div>)
            
        } else {
            
            return (
                <EntityList
                    entities={this.props.entities}
                    config={this.props.config}
                    onClickCard={this.props.onClickCardListing}
                    currentElementHoverId={this.props.currentElementHoverId}
                    onMouseOverElement={this.props.onMouseOverElement}
                />)
        }
        
    }
    
    onClickPagination(numPag) {
        // console.log("EntityListContainer::onClickPagination("+numPag+")");
        // if (this.props.config.pag !== numPag) {
        //Up to top of page.
        //console.log("Haciendo scrollTop paginado");
        // let element = $('#entities-list-container')[0];
        //if (element.length !== 0) {
        $('body,html').stop(true, true).animate({scrollTop: 0}, 200);
        // }
        
        // $('#div-space-buttom').show();
        // $('#entities-list-container').css('visibility', 'hidden');
        //$('#entities-list-container').hide();
        
        // $('#loaderImage').removeClass('fadeOut').addClass('animated-400ms fadeIn');
        $('#loaderImage').show();
        // this.handleHidePreview();
        this.setState({
            indexSelected: undefined
        });
        this.props.onClickPagination(numPag);
        // }
    }
    
    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")
            
            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }
        
        return tkn;
    }
    
    
    render() {
        //console.log("EntityListContainer::render() -> subtipo = '" + this.props?.filtroEntitySeleccionado?.subtipo + "'");
    
        //En el caso de que el resto no sea 0 se añade una paginación más.
        let numPags = 0;
        let showentitiesList, showMap, showListing
        if (this.props.entities) {
            
            if (this.props.config && this.props.config.elementsPerPage !== 0) {
                numPags = Math.trunc(this.props.entities.totalRecords / this.props.config.elementsPerPage);
                if (this.props.entities.totalRecords % this.props.config.elementsPerPage !== 0) {
                    numPags++;
                }
            }
            
            if (this.props.entities && this.props.entities.list && this.props.entities.list.length > 0) {
                showentitiesList = true
                showMap = true
            }
        }
        
        let entities
        
        entities = this.props?.entities?.list?.map(e => ({
            _id: e._id,
            nombre: e.nombre,
            permalink: e.permalink,
            tipo: e.tipo,
            subtipo: e.subtipo,
            locationStr: (e.direccion?.municipio) ? e.direccion.municipio : (e.direccion.region) ? e.direccion.region : e.direccion.provincia,
            location: e.direccion.location,
            img_principal: e.img_principal,
        }))
        
        
        showMap = this.props.config.showMap
        showListing = this.props.config.showListing
        
        
        let listingClassName = ""
        let mapsClassName = "mapContainer "
        if (this.props.config && this.props.config.showListing && this.props.config.showMap) {
            listingClassName = "col-lg-5"
            mapsClassName += "col-lg-5"
        } else if (this.props.config && this.props.config.showMap) {
            listingClassName = "col-lg-6"
            mapsClassName += "col-lg-10"
        } else if (this.props.config && this.props.config.showListing) {
            listingClassName = "col-lg-6"
            mapsClassName += "col-lg-4"
        }
        //console.log("EntityListContainer::render() -> this.props.config.mobileMode = "+this.props.config.mobileMode);
        if (this.props.config.mobileMode) {
            mapsClassName += " not-margin"
        }
        
        
        return (
            <div>
                {/*<div className="cardInfoTitle">*/}
                {/*    <h1 className="">*/}
                {/*        {title}*/}
                {/*    </h1>*/}
                {/*</div>*/}
                <div className="row">
                    <div id="" className="col-lg-2">
                        <EntitiesFilter
                            config={this.props.config}
                            paramsFilter={this.props.paramsFilter}
                            totalRecords={this.props.entities.totalRecords}
                            filtroEntitySeleccionado={this.props.filtroEntitySeleccionado}
                            onSearchCurrentLocation={this.props.onSearchCurrentLocation}
                            
                            onChangeFilter={this.props.onChangeFilter}
                            onShowMap={this.props.onShowMap}
                            onShowListing={this.props.onShowListing}
                            filterControl={"filtersControl"}
                            varsData={{}}
                        />
                        <AdsManagerContainer type={ADS_TYPES.SKYSCRAPER} onlyDesktop sticky/>
                    </div>
                    
                    {
                        showListing &&
                        <div id="entities-list-container" className={listingClassName}>
                            <div className="listing-houses">
                                
                                
                                {this.renderentitiesList(showentitiesList)}
                                
                                
                                <nav className="listings-pagination d-flex justify-content-center">
                                    {numPags > 0 && (
                                        <Pagination
                                            config={this.props.config}
                                            pageCount={numPags}
                                            onClickPagination={this.onClickPagination}
                                        />
                                    )}
                                </nav>
                            </div>
                        </div>
                    }
                    {
                        showMap &&
                        <div id="" className={mapsClassName}>
                            <MapContainer
                                config={this.props.config}
                                totalRecords={this.props.entities.totalRecords}
                                entitiesList={entities}
                                viewport={this.props.entities.metadata.geo.viewport}
                                location={this.props.entities.metadata.geo.location}
                                geoInfo={this.props.entities.metadata.geo}
                                onSearchCurrentLocation={this.props.onSearchCurrentLocation}
                                onSearchInBoundsLocation={this.props.onSearchInBoundsLocation}
                                userLocation={this.props.userLocation}
                                geoInBounds={this.props.geoInBounds}
                                currentElementHoverId={this.props.currentElementHoverId}
                                onMouseOverElement={this.props.onMouseOverElement}
                                onClickCard={this.props.onClickCardMap}
                            />
                            {/*<AdsManagerContainer type={ADS_TYPES.BILLBOARD} onlyDesktop={!this.props.config.mobileMode}/>*/}
                        </div>
                    }
                
                </div>
                <ItemList_Schema_org
                    itemList={this.props.entities.list}
                    HOST={process.env.HOST_ADOPTA}
                
                />
            
            </div>
        );
    }
    
    componentWillMount() {
        $('#not-found-container').hide()
        $('#div-space-buttom').show();
    }
    
    componentDidMount() {
        $('#not-found-container').hide()
        $('body,html').stop(true, true).animate({scrollTop: 0}, 0);
        
        $('#entities-list-container').css('visibility', 'visible');
        $('#div-space-buttom').hide();
        
        $('#loaderImage').hide();
        
    }
    
    
    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.entities.list.length === 0) {
            $('#not-found-container').show()
        } else {
            $('#not-found-container').hide()
        }
    }
    
    
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default EntityListContainer
